import { useAuthClient } from '@gef-ui/authorization-v2';
import { getLabelMessage } from '@gef-ui/localization/messages';
import DoorOpenRegular from '@gef-ui/material-icons/DoorOpenRegular';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React from 'react';
const LogoutButton = ({ error })=>{
    const authClient = useAuthClient();
    let onClick;
    if (error.logoutUrl) {
        onClick = ()=>{
            window.location.replace(error.logoutUrl);
        };
    } else if (authClient?.handleLogout) {
        onClick = authClient.handleLogout;
    }
    if (onClick) {
        return /*#__PURE__*/ React.createElement(Button, {
            startIcon: /*#__PURE__*/ React.createElement(DoorOpenRegular, null),
            onClick: onClick,
            id: "error-logout-button"
        }, getLabelMessage('common:logout'));
    } else {
        return null;
    }
};
LogoutButton.propTypes = {
    error: PropTypes.object
};
export default LogoutButton;
